import { Config } from "../config/Config";
import Intro from "../pages/introScreen/Intro";

import ManageHousehold from "../pages/household/ManageHousehold";
import EditHousehold from "../pages/household/EditHousehold";
import ResetPassword from "../pages/auth/ResetPassword";
import EditProfile from "../pages/profile/EditProfile";
import Faqs from "../pages/faq/Faqs";
import Chores from "../pages/chores/Chores";
import Expenses from "../pages/expenses/Expenses";
import Home from "../pages/home/Home";
import ManageProfile from "../pages/profile/ManageProfile";
import Profile from "../pages/profile/Profile";
import AddHousehold from "../pages/household/AddHousehold";
import AddInvite from "../pages/household/AddInvite";
// import Subscription from "../pages/subscription/CopySubscription";
import Subscription from "../pages/subscription/Subscription";
import Contributions from "../pages/contributions/Contributions";
import Dashboard from "../pages/dashboard/Dashboard";
import Reports from "../pages/reports/Reports";
import HouseholdMembers from "../pages/household/HouseholdMembers";
import PrivacyPolicy from "../pages/cms/CmsPages";
import Main from "../pages/auth/Main";
import Login from "../pages/auth/Login";

import SignUp from "../pages/auth/SignUp";
import Otp from "../pages/auth/Otp";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ChangePassword from "../pages/auth/ChangePassword";
import ContactUs from "../pages/contactUs/ContactUs";
import PaymentSuccess from "../pages/subscription/PaymentSuccess";
import EditHouseholdMember from "../pages/household/EditHouseholdMember";
import PrivacyPolicyPublic from "../pages/cms-public/PrivacyPolicy";
import NotificationSettings from "../pages/notificationSettings/NotificationSettings";
import Notifications from "../pages/notifications/Notifications";
import OpportunityCost from "../pages/opportunityCost/OpportunityCost";
import Payment from "../pages/payment/Payment";
import HouseholdInvitation from "../pages/auth/HouseholdInvitation";
import ContributuonReportPopup from "../pages/reports/ContributuonReportPopup";
import StripeSetupCompleted from "../pages/StripeSetupCompleted/StripeSetupCompleted";
import TermsAndConditionsPublic from "../pages/cms-public/TermsAndConditions";

export const Routes = {
  Main: Config?.url + "/",
  HouseholdInvitation: Config?.url + "/household-invitation",
  Login: Config?.url + "/login",
  SignUp: Config?.url + "/signup",
  Otp: Config?.url + "/verify-otp",
  ForgotPassword: Config?.url + "/forgot-password",
  ResetPassword: Config?.url + "/reset-password",
  ManageProfile: Config?.url + "/manage-profile",
  ChangePassword: Config?.url + "/change-passsword",
  NotificationSettings: Config?.url + "/notification-settings",
  Notifications: Config?.url + "/notifications",
  StripeSetupCompleted: Config?.url + "/stripeSetupCompleted",
  Payment: Config?.url + "/payment",
  OpportunityCost: Config?.url + "/opportunity-cost",
  ContactUs: Config?.url + "/contact-us",
  Profile: Config?.url + "/profile",
  Home: Config?.url + "/home",
  AddHousehold: Config?.url + "/add-household",
  AddInvite: Config?.url + "/add-household-member",
  Subscription: Config?.url + "/subscription",
  Contributions: Config?.url + "/contributions",
  Dashboard: Config?.url + "/dashboard",
  Reports: Config?.url + "/reports",
  ReportContribution: Config?.url + "/reports-contribution",
  HouseholdMembers: Config?.url + "/household-members",
  PrivacyPolicy: Config?.url + "/privacypolicy",
  CmsPages: Config?.url + "/pages/",
  UpdateProfile: Config?.url + "/edit-profile",
  Faqs: Config?.url + "/faqs",
  Chores: Config?.url + "/chores",
  Expenses: Config?.url + "/expenses",
  Intro: Config?.url + "/intro",
  ManageHousehold: Config?.url + "/manage-household",
  EditHousehold: Config?.url + "/edit-household",
  PaymentSuccess: Config?.url + "/payment-success",
  EditHouseholdMember: Config?.url + "/edit-household-member",
  PrivacyPolicyPublic: Config?.url + "/privacy-policy",
  TermsAndConditionsPublic: Config?.url + "/terms-and-conditions",
};

export const publicRoutes = [
  /*==== Dashboard Route ====*/
  // {
  //   // path: Routes?.Home,
  //   path: Routes?.Main,
  //   element: <Home />
  // },
  {
    path: Routes?.HouseholdInvitation,
    element: <HouseholdInvitation />,
  },
  {
    path: Routes?.Login,
    element: <Login />,
  },
  {
    path: Routes?.SignUp,
    element: <SignUp />,
  },
  {
    path: Routes?.Otp,
    element: <Otp />,
  },
  {
    path: Routes?.ForgotPassword,
    element: <ForgotPassword />,
  },
  {
    path: Routes?.ResetPassword,
    element: <ResetPassword />,
  },
  {
    path: Routes?.ContactUs,
    element: <ContactUs />,
  },
  {
    path: Routes?.Intro,
    element: <Intro />,
  },
  {
    path: `${Routes?.CmsPages}:slug`,
    element: <PrivacyPolicy />,
  },
  {
    path: Routes?.Faqs,
    element: <Faqs />,
  },
  {
    path: Routes?.PrivacyPolicyPublic,
    element: <PrivacyPolicyPublic />,
  },
  {
    path: Routes?.StripeSetupCompleted,
    element: <StripeSetupCompleted />,
  },
  {
    path: Routes?.TermsAndConditionsPublic,
    element: <TermsAndConditionsPublic />,
  },
];

export const privateRoutes = [
  // {
  //   path: Routes?.HouseholdInvitation,
  //   element: <HouseholdInvitation />,
  // },
  {
    path: Routes?.ManageProfile,
    element: <ManageProfile />,
  },
  {
    path: Routes?.Profile,
    element: <Profile />,
  },
  {
    path: Routes?.AddHousehold,
    element: <AddHousehold />,
  },
  {
    path: Routes?.AddInvite,
    element: <AddInvite />,
  },
  {
    path: Routes?.Subscription,
    element: <Subscription />,
  },
  {
    path: Routes?.Contributions,
    element: <Contributions />,
  },
  {
    path: Routes?.Dashboard,
    element: <Dashboard />,
  },
  {
    path: Routes?.Reports,
    element: <Reports />,
  },
  {
    path: Routes?.ReportContribution,
    element: <ContributuonReportPopup />,
  },
  {
    path: Routes?.HouseholdMembers,
    element: <HouseholdMembers />,
  },
  {
    path: Routes?.UpdateProfile,
    element: <EditProfile />,
  },
  {
    path: `${Routes?.EditHouseholdMember}/:id`,
    element: <EditHouseholdMember />,
  },
  {
    path: Routes?.ChangePassword,
    element: <ChangePassword />,
  },
  {
    path: Routes?.NotificationSettings,
    element: <NotificationSettings />,
  },
  {
    path: Routes?.Notifications,
    element: <Notifications />,
  },
  {
    path: Routes?.OpportunityCost,
    element: <OpportunityCost />,
  },
  {
    path: Routes?.Payment,
    element: <Payment />,
  },
  {
    path: Routes?.Chores,
    element: <Chores />,
  },
  {
    path: Routes?.Expenses,
    element: <Expenses />,
  },
  {
    path: Routes?.ManageHousehold,
    element: <ManageHousehold />,
  },
  {
    path: Routes?.EditHousehold,
    element: <EditHousehold />,
  },
  {
    path: Routes?.PaymentSuccess,
    element: <PaymentSuccess />,
  },
];
